<script>
    import {Form} from '../../helpers/Form/Form'
    export default {
        name: 'SaveSearchForm',
        props: {
            model: String,
            email: String
        },
        data() {
            return {
                form: new Form({
                    email: this.email,
                    latitude: null,
                    longitude: null,
                    search_string: null,
                    filters: {
                        age: null,
                        disabilities: [],
                        days: [],
                        municipality: null,
                        startTime: null
                    },
                    model: this.model,
                    municipality: null,
                    city: null,
                }),
                disabilities: [],
                filters: {},
                submitted: false,
            }
        },
        mounted() {
            this.form.latitude = this.getParameterByName('latitude')
            this.form.longitude = this.getParameterByName('longitude')
            this.form.search_string = this.getParameterByName('search_string')
            this.form.city = this.getParameterByName('city')
            this.form.municipality = this.getParameterByName('municipality')
            this.getDisabilities()
            this.$bus.$on('update-filters', this.updateFilters)
        },
        computed: {
            orderedDays() {
                let lastDay = this.commonWeekDays.shift()
                this.commonWeekDays.push(lastDay)
                return this.commonWeekDays
            }
        },
        methods: {
            onSubmit() {
                this.form
                    .submit('post', route('search.save'), {}, true)
                    .then((data) => {
                        let results = data.result
                        $("#saveSearchModal").modal('toggle')
                        window.alerts.success('La tua ricerca è stata salvata con successo');
                    }).catch((error) => {
                        window.alerts.error('Si è verificato un errore durante il salvataggio');
                    })
            },
            updateFilters(filters) {
                this.$set(this.form, 'filters', filters)
            },
            getDisabilities() {
                axios({
                    method: 'get',
                    url: '/disabilities'
                }).then(({data}) => {
                    this.disabilities = data.disabilities
                }).catch((error) => {
                    //
                })
            },
            getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, '\\$&');

                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);

                if (!results) return null;
                if (!results[2]) return '';

                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/search/SaveSearchForm.vue